import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Bid: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		ZpracovosdatId: null as number | null,
		Bid: null as string | null,
		BidText: null as string | null,
		Text: null as string | null,
		GdprSouhlasTxtC1: '',
		GdprSouhlasTxtC2: '',
		GdprSouhlasTxtC3: '',
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		SouhlasPlatnost: null as number | null,
		KoncernPrp: null as boolean | null,
		GdprSouhlasFontSize: null as number | null,
	},
	localState: {
		memType: 0 as number | null,
	},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
